import RoutingConfig from '@Constants/rx-user/routing-config.provider';
import AppStorage from '@Services/AppStorage';
import cloneDeep from 'lodash/cloneDeep';

const { userRoles } = RoutingConfig; // empty object for a clean client
const DEFAULT_USER = {
  role: userRoles.public,
  history: {
    breadcrumbs: {},
    viewedResultsParams: {},
    recentSearches: [],
    savedSearches: [],
  },
};
const currentUser = AppStorage.instance.get('currentUser') || cloneDeep(DEFAULT_USER);

export default {
  currentUser,
};
